import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useMemo } from 'react'
import AgencyPlanIcon from 'blaze-ui/icons/20/AgencyPlanIcon'
import Lightbulb1 from 'blaze-ui/icons/20/Lightbulb1'
import ProIcon from 'blaze-ui/icons/20/ProIcon'
import TeamPlanIcon from 'blaze-ui/icons/20/TeamPlanIcon'

export const getPlanIcon = (plan: PaymentPlanKey) => {
  switch (plan) {
    case PaymentPlanKey.BlazeCreator:
      return Lightbulb1
    case PaymentPlanKey.BlazePro:
      return ProIcon
    case PaymentPlanKey.BlazeTeam:
      return TeamPlanIcon
    case PaymentPlanKey.BlazeAgency:
      return AgencyPlanIcon
  }
}

interface Props {
  plan: PaymentPlanKey
  size: number
}

export const PlanIcon = ({ plan, size }: Props) => {
  const PlanIconComponent = useMemo(() => {
    return getPlanIcon(plan)
  }, [plan])

  return <>{!!PlanIconComponent && <PlanIconComponent size={size} />}</>
}
